export default "__VITE_ASSET__5Uecqr9c__"